export default __webpack_public_path__ + "static/media/logo-light.75004bf7.svg";